/* ------------------------- External Dependencies -------------------------- */
import React from 'react'
import { Box } from 'atomic'
import {
  MapAdvancedCompose,
 } from 'foundry'
/* ------------------------------- Component -------------------------------- */
export default props => <Box h={[160,200, 230, 300, 350]}><MapAdvancedCompose delta='organizationFilter' collection='organizations'/></Box>


// WEBPACK FOOTER //
// ./src/interface/foundry/Organization/OrganizationMapSlim/index.js